module.exports = __webpack_public_path__ + "static/media/gallery-new-3.c3080bc9.jpg";